module.exports = __webpack_public_path__ + "static/media/our-values-why-learn.f8645003.png";